import { Button, ButtonProps } from '@/components/ui/Button';
import { cn } from '@/lib/utils';
import { LucideIcon, LucideProps } from 'lucide-react';
import { forwardRef, cloneElement, isValidElement } from 'react';

interface IconButtonProps extends Omit<ButtonProps, 'size'> {
	size?: 'small' | 'medium' | 'large';
}

const iconSizes = {
	small: 'h-4 w-4',  // 16px
	medium: 'h-5 w-5', // 20px
	large: 'h-6 w-6',  // 24px
} as const;

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
	({ children, size = 'medium', className = '', ...props }, ref) => {

		return (
			<Button
				ref={ref}
				size="icon"
				variant="text"
				className={cn('p-0 !min-h-0 !min-w-0', className)}
				{...props}
			>
				{children}
			</Button>
		);
	}
);

IconButton.displayName = 'IconButton'; 